var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirValveOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 23,
    viewBox: "0 0 78 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9861",
    "data-name": "Group 9861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M3.91,23H0V14.85A5.937,5.937,0,0,1,5.97,8.96H78v3.86H5.97a2.044,2.044,0,0,0-2.06,2.03V23Z",
    fill: "#858fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9864",
    "data-name": "Group 9864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9862",
    "data-name": "Group 9862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M45.49,11.85,34.41,19.24V1.21L45.49,8.6,56.56,1.21V19.24Z",
    fill: "#ff16e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9863",
    "data-name": "Group 9863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M55.91,2.42v15.6l-5.85-3.9-4.57-3.05-4.57,3.05-5.85,3.9V2.42l5.85,3.9,4.57,3.05,4.57-3.05,5.85-3.9M33.75,0V20.44l2.03-1.36,5.85-3.9,3.85-2.56,3.85,2.56,5.85,3.9,2.03,1.36V0L55.18,1.36l-5.85,3.9L45.48,7.82,41.63,5.26l-5.85-3.9L33.75,0Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirValveOn);
export default __webpack_public_path__ + "static/media/air_valve_on.b29d056f8c9c351b46c5db022e24b90a.svg";
export { ForwardRef as ReactComponent };